import React from 'react'
import Textarea from '@mui/joy/Textarea'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { FieldValues } from '../IMSFormFieldsTypes'

interface Component {
    id: React.Key | null | undefined
    label_display: any
    label: any
    is_auto_populated?: boolean
    component_response?: { value: any }
    datatype: string
}

interface Group {
    id: React.Key | null | undefined
}

interface IMSFormAccordionTextareaProps {
    component: Component
    group: Group
    fieldValues: FieldValues
    handleFieldChange: (
        groupId: string | number,
        componentId: string | number,
        value: any,
        datatype: string
    ) => void
    shouldShowAutoPopulatedIndicator: (
        component: any,
        fieldValues: FieldValues
    ) => boolean // Assuming this prop is passed down or available
}

const IMSFormAccordionTextarea: React.FC<IMSFormAccordionTextareaProps> = ({
    component,
    group,
    fieldValues,
    handleFieldChange,
    shouldShowAutoPopulatedIndicator,
}) => {
    const AutoPopulateIndicator = () => (
        <FiberManualRecordIcon
            sx={{
                position: 'absolute',
                left: -30,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#209b2e',
                fontSize: '20px',
            }}
            titleAccess="Auto-populated from VIN"
        />
    )

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            {typeof component.id === 'number' &&
                shouldShowAutoPopulatedIndicator(
                    {
                        is_auto_populated: component.is_auto_populated,
                        id: component.id as number,
                        component_response: component.component_response,
                    },
                    fieldValues
                ) && <AutoPopulateIndicator />}
            <Textarea
                id={component.id != null ? String(component.id) : undefined}
                minRows={2}
                size="md"
                style={{
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    maxWidth: '300px',
                }}
                value={
                    component.id != null
                        ? typeof fieldValues[String(component.id)]?.value !==
                          'undefined'
                            ? fieldValues[String(component.id)].value
                            : fieldValues[String(component.id)] || ''
                        : ''
                }
                onChange={(event) => {
                    if (component.id != null) {
                        handleFieldChange(
                            String(group.id),
                            String(component.id),
                            event.target.value,
                            component.datatype
                        )
                    }
                }}
            />
        </div>
    )
}

export default IMSFormAccordionTextarea
